<template>
  <a class="default-logo"
     @click="onLogoClick">
    <img :src="logo" />
  </a>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import logo from './assets/imgs/logo.png'

const router = useRouter()


const onLogoClick = () => {
  router.push('/')
}

</script>

<style scoped lang="less">
.default-logo {
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  min-height: 124px;
  margin: 2px;
  position: relative;

  img {
    max-width: 100%;
    max-height: 100%;
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}
</style>
